import { USER_ROLES } from './enums'

const OBJECT_ID = '[a-fA-F0-9]{24}'
const FACILITY_PATH = new RegExp(`(/facilities/)${OBJECT_ID}`, 'g')
const FACILITY_QUERY = new RegExp(`([?&]facility(?:Id|_id)=)${OBJECT_ID}`, 'g')

export const isSuperUser = (roles = []) => (roles || []).includes(USER_ROLES.SuperUser)

// Super users are the global admins: they can see every facility. Everyone else is limited
// to the facility on their account.
export const accessibleFacilityIds = ({ roles = [], facilityId } = {}) => {
	if (isSuperUser(roles)) return null

	return facilityId ? [String(facilityId)] : []
}

export const canAccessFacility = ({ roles = [], facilityId } = {}, targetId) => {
	if (!targetId) return false

	const allowed = accessibleFacilityIds({ roles, facilityId })

	if (!allowed) return true

	return allowed.includes(String(targetId))
}

export const getAssignedFacilityId = (source = {}) => source?.facility_id || source?.facilityId || null

export const isActiveFacility = (facility) => !!facility?.active

const sameId = (facility, id) => facility && id && String(facility._id) === String(id)

export const findFacilityById = (facilities, id) =>
	(facilities || []).find((facility) => sameId(facility, id)) || null

// An inactive facility must not stay selected. Prefer an active Skiptown facility in the
// same market (so Charlotte does not stay on a closed non-Skiptown site), then any active
// Skiptown facility, then any active facility.
export const pickActiveFacility = (facilities, preferMarketId) => {
	const list = facilities || []
	const activeSkiptown = (facility) => facility.active && facility.skiptown
	const inMarket = (facility) => preferMarketId && String(facility.market_id) === String(preferMarketId)

	return (
		list.find((facility) => activeSkiptown(facility) && inMarket(facility)) ||
		list.find((facility) => activeSkiptown(facility)) ||
		list.find((facility) => facility.active) ||
		null
	)
}

export const resolvePreferredFacilityId = ({
	roles = [],
	assignedFacilityId,
	urlFacilityId,
	storedFacilityId
} = {}) => {
	if (!isSuperUser(roles) && assignedFacilityId) return String(assignedFacilityId)
	return urlFacilityId || storedFacilityId || assignedFacilityId || null
}

export const applyStaffFacilityScopeToUrl = (url, facilityId) => {
	if (!url || !facilityId) return url

	return String(url)
		.replace(FACILITY_PATH, `$1${facilityId}`)
		.replace(FACILITY_QUERY, `$1${facilityId}`)
}

export const applyStaffFacilityScopeToRequest = (config, { roles = [], facility_id } = {}) => {
	if (!config || isSuperUser(roles) || !facility_id) return config
	if (String(config.url || '').includes('paymentStatus')) return config

	const facilityId = String(facility_id)

	if (config.url) {
		config.url = applyStaffFacilityScopeToUrl(config.url, facilityId)
	}

	if (config.params) {
		if (config.params.facility_id) config.params.facility_id = facilityId
		if (config.params.facilityId) config.params.facilityId = facilityId
	}

	return config
}
